import React, { createContext, useContext, useState, ReactNode, useCallback } from "react";

type FlashMessage = {
  id: string;
  type: "success" | "error" | "info" | "warning";
  message: string;
};

type FlashMessageContextType = {
  addMessage: (message: string, type: FlashMessage["type"]) => void;
};

const FlashMessageContext = createContext<FlashMessageContextType | undefined>(undefined);

export const FlashMessageProvider = ({ children }: { children: ReactNode }) => {
  const [messages, setMessages] = useState<FlashMessage[]>([]);

  const addMessage = useCallback((message: string, type: FlashMessage["type"]) => {
    const aplphabetArr: string[] = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
    const id = aplphabetArr[Math.floor(Math.random() * 26)] + Math.floor(Math.random() * 5000000);
    setMessages((prev) => [...prev, { id, type, message }]);

    // Automatically remove the message after 5 seconds
    setTimeout(() => {
      setMessages((prev) => prev.filter((msg) => msg.id !== id));
    }, 2000);
  }, []);

  return (
    <FlashMessageContext.Provider value={{ addMessage }}>
      {children}
      <div className="fixed top-5 right-5 space-y-2" style={{zIndex:99999}}>
        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`flex items-center gap-2 p-4 rounded shadow-md text-white ${msg.type === "success"
              ? "bg-green-500"
              : msg.type === "error"
                ? "bg-secondary"
                : msg.type === "info"
                  ? "bg-blue-500"
                  : "bg-yellow-500"
              }`}
          >
            <span>{msg.message}</span>
            <button
              onClick={() => setMessages((prev) => prev.filter((m) => m.id !== msg.id))}
              className="ml-auto font-bold"
            >
              &times;
            </button>
          </div>
        ))}
      </div>
    </FlashMessageContext.Provider>
  );
};

export const useFlashMessage = () => {
  const context = useContext(FlashMessageContext);
  if (!context) {
    throw new Error("useFlashMessage must be used within a FlashMessageProvider");
  }
  return context;
};
